import { format, parseISO } from 'date-fns';

export const formatDate = (date: string | Date): string => {
    const d = typeof date === 'string' ? parseISO(date) : date;
    return format(d, 'dd-MM-yyyy');
};

export const formatDay = (date: string | Date): string => {
    const d = typeof date === 'string' ? parseISO(date) : date;
    return format(d, 'EEEE');
};

export const formatDateTime = (date: string | Date | number): string => {
    const d = typeof date === 'number' ? new Date(date) : typeof date === 'string' ? parseISO(date) : date;
    return format(d, 'dd-MM-yyyy HH:mm');
};
